


export const firebaseConfig = {
  apiKey: "AIzaSyAno5WQZXQjnzLnd1qOE_2Upf8TipYtmJk",
  authDomain: "pushproba-98c2f.firebaseapp.com",
  projectId: "pushproba-98c2f",
  storageBucket: "pushproba-98c2f.appspot.com",
  messagingSenderId: "15251185127",
  appId: "1:15251185127:web:3c58c7c0532aa4d8c7b142"
};

